import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionHead, Reveal, GoldParticles } from "@/components/common";
import { NftCard } from "@/components/NftCard";
import { NFTS } from "@/data/nfts";

export function NftHero() {
  const { t } = useLang();
  const featured = [NFTS[0], NFTS[11], NFTS[9]];
  return (
    <section className="section-pad relative overflow-hidden py-24" data-testid="nft-hero">
      <GoldParticles count={12} />
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-gold/10 blur-[120px]" />
      <SectionHead eyebrow={t("nft.eyebrow")} title={t("nft.title")} sub={t("nft.sub")} align="center" />
      <div className="mx-auto mt-14 grid max-w-5xl gap-6 sm:grid-cols-3">
        {featured.map((nft, i) => (
          <div key={nft.slug} className={i === 1 ? "sm:-translate-y-6" : ""}>
            <NftCard nft={nft} index={i} />
          </div>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-12 flex flex-wrap justify-center gap-4">
        <Link to="/nfts" className="btn-neon" data-testid="nft-explore-btn">{t("nft.explore")} <ArrowRight size={15} /></Link>
        <Link to="/mint" className="btn-gold" data-testid="nft-eligibility-btn">{t("nft.eligibility")}</Link>
      </Reveal>
    </section>
  );
}
